import { Alert, Anchor, Box, Button, Group } from "@mantine/core";
import { IDocxTemplate } from "@mctypes/global.types";
import * as R from "ramda";
import React, { useState } from "react";
import { useHistory } from "react-router";
import { pathIsInIssueApp } from "../../../app/routes/issuesApp/issueUtils";
import UploadButton from "../../UploadButton";
import { DocxErrorModal } from "../DocxErrorModal";
import DocxDemodataModal from "./DocxDemodataModal";

const NewDocxUpload: React.FC<{
  demoData: any;
  uploadFunc: (event: React.ChangeEvent<HTMLInputElement>, level?: string) => void | Promise<void>;
  uploadCompleedCb: () => void;
  docxTemplates: IDocxTemplate[];
}> = ({ demoData, uploadFunc, uploadCompleedCb, docxTemplates }) => {
  const [showDemoDataModal, setShowDemoDataModal] = useState<boolean>();
  const [dupWarning, setDupWarning] = useState<boolean>(false);
  const [errors, setErrors] = useState<any>(null);

  const history = useHistory();
  const location = history.location;

  const urlIsIssueApp = pathIsInIssueApp(location.pathname);

  const uploadFile = async (event: React.ChangeEvent<HTMLInputElement>, level: string) => {
    setErrors(null);

    // Keep input ref early so we can reset later
    const inputEl = event.target as HTMLInputElement;
    const file = inputEl.files?.[0];

    if (file && docxTemplates?.some((tmpl) => file.name === tmpl.fileName)) {
      setDupWarning(true);
      // Reset so user can immediately pick a new file
      inputEl.value = "";
      return;
    }
    setDupWarning(false);

    try {
      await uploadFunc(event, level);
      uploadCompleedCb();
    } catch (err) {
      const errorToSet = R.pathOr(err, ["response", "data", "error", "error", "properties"], err);
      setErrors(errorToSet);
    } finally {
      // Always clear input
      inputEl.value = "";
    }
  };

  return (
    <Box>
      {showDemoDataModal && <DocxDemodataModal docxDemoData={demoData} close={() => setShowDemoDataModal(false)} />}
      {errors != null && <DocxErrorModal toggle={() => setErrors(null)} errors={errors} />}

      {/* Duplicate warning */}
      {dupWarning && (
        <Box ml="sm">
          <Alert color="yellow" p="xs" mb={0} title="Advarsel">
            Det finnes allerede en mal med dette filnavnet. Gi filen et nytt navn eller slett den eksisterende malen, og
            prøv igjen.
          </Alert>
        </Box>
      )}

      <Group align="center" wrap="nowrap" gap="sm" mt="xs">
        <UploadButton buttonText={"Prosjektmal"} onFileSelected={(event) => uploadFile(event, "PROJECT")} />

        {urlIsIssueApp === true && (
          <UploadButton buttonText={"Registermal"} onFileSelected={(event) => uploadFile(event, "BOARD")} />
        )}

        <Button color="blue" onClick={() => setShowDemoDataModal(true)}>
          Vis demodata
        </Button>

        <Box style={{ flex: 1 }} />

        <Anchor href="https://docxtemplater.com/demo/" target="_blank" rel="noreferrer">
          Se dokumentasjon <i className="fa fa-external-link fa-fw" />
        </Anchor>
      </Group>
    </Box>
  );
};

export default NewDocxUpload;
